import { initializeModal } from './modalUtils';

const responseDialog = document.getElementById('responseDialog');
const responseModal = document.getElementById('responseModal');
const responseContent = document.getElementById('responseContent');
const closeModalButton = document.getElementById('close-responseModal-btn');

const SUCCESS_TITLE = `<h3 class="responseModal__title subheading-3">Your message has been successfully sent. I will get back to you shortly.</h3>`;
const ERROR_TITLE = `<h3 class="responseModal__title subheading-3">This service is unavailable at the moment.
                      Send me a message at
                      <a class="responseModal__mail" href="mailto:zabaraviktoria3@gmail.com">zabaraviktoria3@gmail.com</a>
                     </h3>`;

export const { openModal: openResponseModal, closeModal: closeResponseModal } =
  initializeModal(responseDialog, responseModal, closeModalButton);

export const responseModalContent = status => {
  openResponseModal();

  if (status === 200) {
    responseContent.innerHTML = SUCCESS_TITLE;
    responseModal.classList.replace(
      'responseModal--error',
      'responseModal--success'
    );
  } else {
    responseContent.innerHTML = ERROR_TITLE;
    responseModal.classList.replace(
      'responseModal--success',
      'responseModal--error'
    );
  }
};
